<div class="panel">
  <div class="panel_title">
    Details
  </div>
  <div class="panel_devider"></div>
  <div class="order-info">
    <div class="d-flex align-items-center">
      <div class="order-info_order-id">
        <a (click)="openLink(selectedClaim)"> {{selectedClaim?.ShipmentId}} </a>
        <i class="fal" [ngClass]="{ 'fa-copy': !copied, 'fa-check': copied }"
          [cdkCopyToClipboard]="selectedClaim?.ShipmentId" (cdkCopyToClipboardCopied)="copy($event)"></i>
      </div>
    </div>
    <div class="d-flex align-items-center">
      <div class="order-info_order-date">
        {{selectedClaim?.shipmentName}}
      </div>
      <span class="order-info_data">
        <label class="element-bullets">FC : <span>{{selectedClaim?.destinationWarehouse?.code}}</span></label>
        <!-- <span class="element-bullets">
          <span
            class="order-info_data_status order-info_data_status--{{selectedClaim?.status?.toLowerCase()}}">{{selectedClaim?.status}}</span>
        </span> -->
      </span>
    </div>
  </div>

  <div class="panel_devider"></div>
  <app-sku-info [sku]="selectedClaim"></app-sku-info>
  <div class="panel-detail">
    <span class="panel-detail_value"><span class="label">Qty Shipped</span> <br> {{ selectedClaim?.shippedQty || 0 |
      number }}</span>
    <span class="panel-detail_value"><span class="label">Qty Received</span> <br> {{ selectedClaim?.receivedQty || 0|
      number }}</span>
  </div>
  <div class="panel_devider"></div>
  <div class="amazon-case-template w-100 pt-0">
    <div class="amazon-case">
      <div class="amazon-case_body">
        <div class="amazon-case_header mb-2">
          <div class="amazon-case_header--title">
            Case Template
          </div>
          <app-button [buttonSize]="'action'" [buttonStyle]="'text'" (click)="openCaseDialog(selectedClaim)" *ngIf="!selectedClaim?.isCaseCreated">Open Case</app-button>
        </div>
        <div class="amazon-case_body--templateText p-2 h-auto">
          <p class="font-12" [innerHtml]="selectedTemplate?.formattedText"></p>
        </div>
      </div>
    </div>
  </div>
  <div class="case">
    <div class="case-action">
      <label class="case-action_label">Case Status : </label>
      <mat-select id="status" [(ngModel)]="selectedStatus" (ngModelChange)="onChange($event)" panelClass="caseStatusOption">
        <mat-select-trigger class="case-action_status" [ngClass]="selectedStatus?.status?.toLowerCase()">
          <span class="case-action_span">{{selectedStatus?.status}} <i class="fa fa-chevron-down"></i></span>
        </mat-select-trigger>
        <mat-option [value]="status" *ngFor="let status of claimStatus">
          <div class="case-action_status" [ngClass]="status.status?.toLowerCase()">
            <span>{{ status.status }}</span>
          </div>
        </mat-option>
      </mat-select>
      <ng-container *ngIf="selectedClaim?.CaseStatusId == 4">
        <span [matTooltip]="selectedClaim?.refundedAmount">{{selectedClaim?.refundedAmount | currency}}</span>
        <i *ngIf="selectedClaim.refundedAmount" class="fal fa-edit text-primary hand" [matTooltip]="'Edit'" (click)="openRefundAmount(selectedClaim.refundedAmount)"></i>
        <i *ngIf="!selectedClaim.refundedAmount" class="fal fa-plus-circle text-primary hand" [matTooltip]="'Add'" (click)="openRefundAmount()"></i>
        <i  [matTooltip]="'Refunded'" class="fas fa-check-circle text-success"></i>
      </ng-container>
      
    </div>
    <div class="case-actionLink">
      <label class="case-action_label me-1">Case Link : </label>
      <a class="hand" *ngIf="!selectedClaim?.caseLink" (click)="openDialog(true)">+ Add Link</a>
      <a class="hand" *ngIf="selectedClaim?.caseLink" [matTooltip]="selectedClaim?.caseLink">{{selectedClaim?.caseLink}}</a>
      <i *ngIf="selectedClaim?.caseLink" class="fal fa-trash-alt text-red hand ms-2"
        (click)="updateStatus(true)"></i>
    </div>
  </div>

  <div class="panel_devider"></div>
  <div>
    <div class="panel_title font-12 d-flex align-items-center mt-0 mb-2">
      Note
      <div class="d-flex ms-auto">
        <i class="fal fa-edit text-primary hand" *ngIf="!isNote" (click)="showNote()"></i>
        <app-button *ngIf="isNote" [buttonSize]="'action'" [buttonStyle]="'text'"
        (click)="cancel()">Cancel</app-button>

        <app-button *ngIf="isNote" [buttonSize]="'action'" [buttonStyle]="'text'"
          (click)="updateStatus(null,true)">Save</app-button>
      </div>
    </div>
    <div *ngIf="!isNote" class="text">
      <h2>{{selectedClaim?.note}}</h2>
    </div>
    <textarea [formControl]="note" *ngIf="isNote"
      class="form-control p-2 font-12 resize-none">{{selectedClaim?.note}}</textarea>
  </div>
</div>

<!-- <div class="panel_footer">
  <app-button [buttonSize]="'action'">Download BOL</app-button>
  <app-button [buttonSize]="'action'">Download Invoice</app-button>
</div> -->